import {Repository} from "./Repository";
import {AxiosInstance} from "axios";
import {Schema} from "../models/Schema";

//USELESS:
export class SchemaRepository implements Repository {
    client: AxiosInstance;

    constructor(client: AxiosInstance) {
        this.client = client;
    }

    find(id: string) {
        return this.client.get(`/schemas/${id}`)
            .then(({data}) => {
                return new Schema(data);
            })
    }
}